import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ScrollText } from "lucide-react";

const ACTION_LABELS = {
  team_create: "Added team member",
  team_remove: "Removed team member",
  waitlist_invite: "Sent waitlist invite",
  settings_update: "Updated site settings",
};

export default function ActivityLog() {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/team/activity");
      setRows(data);
    })();
  }, []);

  return (
    <div className="mt-10 rounded-xl border border-[#27272A] bg-[#121212] p-6" data-testid="activity-log-panel">
      <div className="flex items-center gap-2">
        <ScrollText className="h-4 w-4 text-[#007AFF]" />
        <h2 className="font-black text-xl tracking-tight">Team activity</h2>
      </div>
      <p className="mt-1 text-xs text-neutral-500">Who did what — keeps launch week accountable.</p>

      <div className="mt-4 space-y-1.5 max-h-80 overflow-y-auto pr-1" data-testid="activity-log-list">
        {rows === null ? (
          <div className="text-sm text-neutral-500">Loading…</div>
        ) : rows.length === 0 ? (
          <div className="text-sm text-neutral-500" data-testid="activity-empty">No activity recorded yet.</div>
        ) : rows.map((r) => (
          <div key={r.id} className="flex items-start justify-between gap-4 rounded-md bg-[#0A0A0A] border border-[#27272A] px-3.5 py-2.5">
            <div className="min-w-0">
              <span className="text-sm text-white font-medium">{ACTION_LABELS[r.action] || r.action}</span>
              <span className="text-xs text-neutral-500 ml-2">{r.detail}</span>
              <div className="text-[11px] text-neutral-600 mt-0.5">
                by <span className="text-neutral-400">{r.actor_email}</span> ({r.actor_role})
              </div>
            </div>
            <span className="text-[11px] text-neutral-600 flex-shrink-0 mt-0.5">{new Date(r.at).toLocaleString()}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
